import GetAllCategories from '@/services/api/products/GetAllCategories'
import {Menu, Transition} from '@headlessui/react'
import {
  Dispatch,
  Fragment,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react'
import {useQuery} from 'react-query'

interface Props {
  setCategory: Dispatch<SetStateAction<string>>
  category: string
}
export default function SearchDropdown({setCategory, category}: Props) {
  const {data} = useQuery(['categories'], GetAllCategories)

  return (
    <div className="relative w-56 text-left z-20">
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <Menu.Button className="inline-flex px-4 w-full items-center justify-center rounded-md py-2 text-sm font-medium text-primary hover:text-primary-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-opacity-75">
            {category === ''
              ? 'كل التصنيفات'
              : data.filter((x: any) => x.slug == category)[0]['name']}
            <span className="mr-2">
              <svg
                width="9"
                height="4"
                viewBox="0 0 9 4"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.831161 -3.27873e-07C0.963874 0.000117938 1.09111 0.0535775 1.1849 0.148625L3.74513 2.74011C3.82261 2.81855 3.91459 2.88078 4.01582 2.92323C4.11706 2.96568 4.22556 2.98753 4.33514 2.98753C4.44472 2.98753 4.55322 2.96568 4.65445 2.92323C4.75569 2.88078 4.84767 2.81855 4.92514 2.74011L7.48371 0.152003C7.57812 0.0597078 7.70457 0.00863755 7.83581 0.00979198C7.96706 0.0109464 8.09261 0.0642332 8.18542 0.158175C8.27823 0.252118 8.33087 0.379199 8.33201 0.512048C8.33315 0.644897 8.2827 0.772885 8.19152 0.868446L5.63495 3.45656C5.29047 3.80455 4.82366 4 4.33697 4C3.85029 4 3.38348 3.80455 3.039 3.45656L0.47876 0.865068C0.408809 0.794309 0.361131 0.704161 0.341744 0.606002C0.322357 0.507843 0.33213 0.406071 0.369829 0.313528C0.407528 0.220985 0.471464 0.141819 0.553568 0.0860195C0.635673 0.0302199 0.732266 0.000287561 0.831161 -3.27873e-07Z"
                  fill="#00214D"
                />
              </svg>
            </span>
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95">
          <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="px-1 py-1 ">
              <Menu.Item>
                <button
                  onClick={() => {
                    setCategory('')
                  }}
                  className={`group flex w-full items-center rounded-md px-2 py-2 text-sm transition duration-200 hover:text-primary-300`}>
                  كل التصنيفات
                </button>
              </Menu.Item>
              {data?.map((category: any, index: number) => {
                return (
                  <Menu.Item key={index}>
                    <button
                      onClick={() => {
                        setCategory(category.slug)
                      }}
                      className={`group flex w-full items-center rounded-md px-2 py-2 text-sm transition duration-200 hover:text-primary-300`}>
                      {category.name}
                    </button>
                  </Menu.Item>
                )
              })}
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  )
}
